var React = require('react');

function SocialLinkedinInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FFF","fillRule":"evenodd","d":"M4.54 6.18V19H.253V6.18H4.54zm.283-3.966c0 1.231-.931 2.216-2.426 2.216H2.37C.93 4.43 0 3.445 0 2.214 0 .957.959 0 2.425 0c1.467 0 2.37.957 2.398 2.214zM20 11.65V19h-4.287v-6.858c0-1.723-.62-2.898-2.172-2.898-1.184 0-1.89.792-2.2 1.558-.113.274-.14.656-.14 1.04V19H6.912s.057-11.617 0-12.82H11.2v1.816c.57-.873 1.588-2.117 3.864-2.117 2.821 0 4.936 1.833 4.936 5.77z"}));
}

SocialLinkedinInline.defaultProps = {"width":"20","height":"19","viewBox":"0 0 20 19"};

module.exports = SocialLinkedinInline;

SocialLinkedinInline.default = SocialLinkedinInline;
